import { render, staticRenderFns } from "./BuyCarPop.vue?vue&type=template&id=cfcad4d4&scoped=true"
import script from "./BuyCarPop.vue?vue&type=script&lang=ts"
export * from "./BuyCarPop.vue?vue&type=script&lang=ts"
import style0 from "./BuyCarPop.vue?vue&type=style&index=0&id=cfcad4d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcad4d4",
  null
  
)

export default component.exports